export default __webpack_public_path__ + "static/media/BLR24.525269e9.jpg";